// to set the given header name 
//==============================

export const setHeaderName = (data) => {
    localStorage.setItem('title', data)
}
